export const APPROVAL_LIST = "APPROVAL_LIST";
export const ACCEPT = "ACCEPT";
export const REJECT = "REJECT";
export const SITE_ABORT_APPROVAL = "SITE_ABORT_APPROVAL";
export const SITE_ABORT_APPROVAL_FINANCE = "SITE_ABORT_APPROVAL_FINANCE";
export const FETCH_APPROVE_REJECT_LIST = "FETCH_APPROVE_REJECT_LIST";
